module.exports = __webpack_public_path__ + "media/images/bag-7f38d84fc171be60938aec48faaa172c.svg";